import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogContentText, Button, ThemeProvider } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { commonTheme } from "../commonTheme";
export default function AlertDialog(props: any) {
    const { handleClose, handleSubmit, dialogState, dialogContent, trueButtonName, falseButtonName } = props
    const [open, setOpen] = React.useState(dialogState?.isOpen);
    const onOpenClick = () => {
        handleSubmit(dialogState);
        handleClose(undefined)
    };

    const onCloseClick = () => {
        setOpen(undefined)
        handleClose(undefined)
    };

    return (
        <div>
            <ThemeProvider theme={commonTheme}>
                <Dialog
                    open={open}
                    onClose={onCloseClick}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Typography variant="h2">{dialogContent}</Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCloseClick} disableElevation type="submit" variant='contained' style={{ textTransform: 'inherit' }}>{falseButtonName || 'No'}</Button>
                        <Button onClick={onOpenClick} disableElevation type="submit" variant='contained' style={{ textTransform: 'inherit' }} color='secondary' autoFocus>
                            {trueButtonName || 'Yes'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
        </div>
    );
}
